export default __webpack_public_path__ + "static/media/speaker.99b69fe2.svg";